<template>
  <div class="container-guide" @touchmove.prevent>
     <div class="circle-item" @click="$emit('iconClick')">
       <img class="icon-con" src="../../../../assets/images/iconf.png" alt="">
     </div>
    <div class="mask" @click="$emit('closeMask')">
      <img class="guid-img" src="../../../../assets/images/guidef.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
    name: 'index'
};
</script>

<style lang="scss" scoped>
.container-guide {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1000;
  .mask{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .6);
    display: flex;
    justify-content: center;
    flex-direction: row;
  }
  .guid-img{
    width: 333px;
    height: 183px;
    margin-top: 166px;
  }

    .icon-con{
      width: 80px;
      height: 80px;
      position: absolute;
      right: 2px;
      top:61px;
    }
}
</style>